/**
 * UPLOAD ERROR PAGE
 *
 * @version 0.1
 */

import React from 'react';

import reduxStore from './../../../../reduxStore';

import SubscriptionExceededError from './ErrorPage.subscriptionExceededError.jsx';
import FileReadingError from './ErrorPage.fileReadingError.jsx';

export default class ErrorPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = reduxStore.getState().batchUpload;
    }

    componentWillMount() {
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState().batchUpload);
            }
        );
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    componentDidMount() {
        reduxStore.dispatch({type: 'HIDE_SPINNER'});
    }

    render() {

        return (
            <div className="upload-preview-page error">
                {this.state.subscriptionExceeded ?
                <SubscriptionExceededError /> :
                <FileReadingError triggerSelectFile={this.props.triggerSelectFile}/>}
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/ErrorPage/ErrorPage.index.jsx